import { defineEffect } from '../../../core/effect';
import { spec } from '../fx/chain_solving';

/** 状況 `chain_solving_zoom`（組み立ては `../fx/chain_solving.js`。arcade はどの状況も同じ絵） */
export default defineEffect({ situation: 'chain_solving_zoom', role: 'effect', ...spec }, 'chain_solving_zoom_effect.js');
